import { render, staticRenderFns } from "./ConsolidationTableMobile.vue?vue&type=template&id=844e3cf4&scoped=true"
import script from "./ConsolidationTableMobile.vue?vue&type=script&lang=js"
export * from "./ConsolidationTableMobile.vue?vue&type=script&lang=js"
import style0 from "./ConsolidationTableMobile.vue?vue&type=style&index=0&id=844e3cf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "844e3cf4",
  null
  
)

export default component.exports